// extracted by mini-css-extract-plugin
module.exports = {"flagshipInfo":"events_flagshipInfo__F2LjB","flagshipCard":"events_flagshipCard___in6n","flagshipMobile":"events_flagshipMobile__6sco8"};